import { RouteRecordRaw } from "vue-router";
import { ROLES_AND_PERMISSION_ON_ROUTES } from "@/core/configs/rolesAndPermissionsMappingOnRoutes";
import { PATH } from "@/core/constants/path";

const routes: Array<RouteRecordRaw> = [
  {
    path: PATH.HOTELS,
    name: "hotelSearch",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.HOTELS.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.HOTELS.PERMISSIONS,
    },
    component: () => import("@/modules/Hotel/views/HotelSearch.vue"),
  },
  {
    path: PATH.HOTELS_SEARCH_RESULT,
    name: "hotelSearchResults",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.HOTELS.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.HOTELS.PERMISSIONS,
    },
    component: () => import("@/modules/Hotel/views/HotelSearchResults.vue"),
  },
  {
    path: PATH.HOTEL_PROPERTY_VIEW,
    name: "hotelPropertyView",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.HOTELS.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.HOTELS.PERMISSIONS,
    },
    component: () => import("@/modules/Hotel/views/HotelPropertyView.vue"),
  },
  {
    path: PATH.HOTEL_PROPERTY_BOOKING_FORM,
    name: "hotelPropertyBookingForm",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.HOTELS.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.HOTELS.PERMISSIONS,
    },
    component: () =>
      import("@/modules/Hotel/views/HotelPropertyBookingForm.vue"),
  },
  {
    path: PATH.HOTEL_BOOKING_DETAILS,
    name: "hotelBookingDetails",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.HOTELS_BOOKING_DETAILS.ROLES,
      permissions:
        ROLES_AND_PERMISSION_ON_ROUTES.HOTELS_BOOKING_DETAILS.PERMISSIONS,
    },
    component: () => import("@/modules/Hotel/views/HotelBookingDetails.vue"),
  },
];

export default routes;
